module.exports = __webpack_public_path__ + "static/media/indian-army.16a8b290.svg";